import { __assign, __rest } from "tslib";
import React from "react";
import { Spinner, StyledButton } from "./styles";
import { hexToRgb } from "../../../utils/functions";
function Button(_a) {
    var title = _a.title, disabled = _a.disabled, onClick = _a.onClick, icon = _a.icon, type = _a.type, isLoading = _a.isLoading, textStyle = _a.textStyle, inverted = _a.inverted, containerStyles = _a.containerStyles, buttonColor = _a.buttonColor, rest = __rest(_a, ["title", "disabled", "onClick", "icon", "type", "isLoading", "textStyle", "inverted", "containerStyles", "buttonColor"]);
    var rgbColor = hexToRgb(buttonColor);
    return (React.createElement(StyledButton, __assign({ type: type, inverted: inverted, disabled: disabled, onClick: function (e) {
            if (onClick) {
                onClick(e);
            }
        }, style: containerStyles, buttonColor: rgbColor }, rest), isLoading ? (React.createElement(Spinner, { inverted: inverted, spinnerColor: rgbColor })) : (React.createElement("div", { style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10
        } },
        icon,
        title && React.createElement("span", { style: textStyle }, title)))));
}
Button.defaultProps = {
    type: "button",
    disabled: false,
    isLoading: false,
    inverted: false,
    onClick: function () { },
    buttonColor: "#ff2c3a"
};
export default Button;
//# sourceMappingURL=index.js.map